/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';

export class Notice extends AbstractObject {
  type: string;
  model: string;
  modelId: uuid;
  readAt: number; // Date....

  constructor(o: Partial<Notice> = {}) {
    super(o);
  }

  static getType(n: Notice) {
    if (n.type) {
      return n.type.substring(n.type.lastIndexOf("\\") + 1)
    } else {
      return 'Unknown';
    }
  }
}
